import React, { useState } from 'react';
import '../styles/ContactForm.scss';


export default function ContactForm() {
    const [form, setForm] = useState({ name: '', phone: '', email: '', city: '', message: '' });
    const [sent, setSent] = useState(false);


    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
    const onSubmit = (e) => {
        e.preventDefault();
        // in production send to backend / API
        setSent(true);
        setTimeout(() => setSent(false), 3000);
    };


    return (
        <section id="contact" className="contact">
            <div className="container">
                <h2>Contact & Enquiries</h2>
                <div className="contact-grid">
                    <form className="contact-form" onSubmit={onSubmit} aria-label="Contact form">
                        <label>
                            <span>Name</span>
                            <input name="name" value={form.name} onChange={onChange} required />
                        </label>


                        <label>
                            <span>Phone</span>
                            <input name="phone" value={form.phone} onChange={onChange} required />
                        </label>


                        <label>
                            <span>Email</span>
                            <input name="email" type="email" value={form.email} onChange={onChange} />
                        </label>

                        <label>
                            <span>City</span>
                            <input name="city" type="text" value={form.city} onChange={onChange} />
                        </label>


                        <label>
                            <span>Message</span>
                            <textarea name="message" value={form.message} onChange={onChange} rows={4} placeholder='Any message for us' />
                        </label>


                        <div className="form-actions">
                            <button className="btn primary" type="submit">Request Brochure</button>
                            <button className="btn ghost" type="button" onClick={() => window.open('https://wa.me/919730020099')}>WhatsApp</button>
                        </div>


                        {sent && <div className="sent">Thank you — we will contact you shortly.</div>}
                    </form>


                    <aside className="contact-info">
                        <h3>Visit Us For</h3>
                        <p>Get in touch or visit us to experience Lonavalley firsthand.</p>
                        <div className="map-embed" aria-hidden>
                            {/* Placeholder for embedded Google Map iframe (replace with real iframe in production) */}
                            <div className="map-fake">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3464.217726750294!2d73.81975727470652!3d18.45998387102306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc295005759f761%3A0x68ac92bd3c8645f6!2sSamriddhi%20group!5e1!3m2!1sen!2sin!4v1757673194377!5m2!1sen!2sin"
                                    width="400"
                                    height="300"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>

                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );
}